import { Button, List, ListItem, ListItemText, Paper } from "@mui/material";
import React from "react";
import { SystemValueInterface } from "../../Api/System";
import CategoryTitle from "../atoms/CategoryTitle";
import { ChargeCategoryDialog } from "./ChargeCategoryDialog";

interface ChargeCategorySettingsProps {
    systemValue?: SystemValueInterface
    onSave?: (key: string, value: string) => void
}

const ChargeCategorySettings: React.FC<ChargeCategorySettingsProps> = ({
    systemValue,
    onSave
}) => {
    const [dialog, setDialog] = React.useState<boolean>(false)

    return (
        <Paper sx={{ margin: "10px" }}>
            <CategoryTitle
                text="料金カテゴリー設定"
            />
            <List>
                <ListItem>
                    <ListItemText primary={"料金カテゴリー設定"} />
                    <Button
                        variant="outlined"
                        sx={{
                            maxWidth: 300
                        }}
                        fullWidth
                        onClick={() => {
                            setDialog(true)
                        }}
                    >
                        設定
                    </Button>
                </ListItem>
            </List>
            <ChargeCategoryDialog
                open={dialog}
                onClose={() => {
                    setDialog(false)
                }}
            />
        </Paper>
    );
}

export default ChargeCategorySettings